<!-- 
  VISUALIZACAO DOS TITULOS DO PEDIDO/NOTA FISCAL
-->

<script>
import { SysVars } from '../main';
import { getText, formatDate, formatValue } from '../shared/utils'
import { apiDownload, apiDownloadPDF, urlORDS } from '../shared/api-functions'

export default {
    props: {
        finList: Array
    },

    data () {
        return {
            receber: 0,
            recebido: 0,
            vencido: 0,
            urlboleto: 'fin/boleto/',
        }
    },
    computed: {
        metadata: function () {
            return this.$store.getters.getEntities.metadata
        },
    },

    filters: {
        format: function (value) {
            return formatValue(value, 2)
        },
    },

    methods: {

        closeForm () {
            this.$emit('closeform')
        },

        data (value) {
            return formatDate(value)
        },        

        totalizaTitulos () {
            //CALCULA OS TOTAIS

            this.receber = 0
            this.recebido = 0
            this.vencido = 0

            if (!this.finList.length) {
                return
            }

            var d = new Date()

            for (var x = 0; x <= this.finList.length - 1; x++) {
                if (this.finList[x].baixado === 'S') {
                    this.recebido = this.recebido + this.finList[x].vlr
                } else
                if (this.finList[x].dtv < d) {
                    this.vencido = this.vencido + this.finList[x].vlr
                } else {
                    this.receber = this.receber + this.finList[x].vlr
                }
            }

        },

        handleEmiteBoleto(codfin) {
            //EMISSAO DO BOLETO DO TITULO SELECIONADO
            let sendData = { titulos: [ 
                    {codfin: codfin }
                    ] }
            apiDownloadPDF(this, this.urlboleto, sendData, 'post')
        },

        async handleBaixar(codfin) {
            //EFETUA A BAIXA DO TITULO
            var sendData = { titulos: [ { codfin: codfin } ] }
            const data = await apiORDSpost(this.$store, 'fin/ar/pay/', sendData, 'post')
            if (data.errmessages) {
              this.errmessages = data.errmessages
              this.$erpToastError(data.errmessages[0])
            } else {
              this.$erpToastSuccess('Baixa efetivada com sucesso.')
            }
        },


    },

    watch: {

    },

    components: {

    },

    created () {
        this.totalizaTitulos()
        this.$nextTick(function () {
            jQuery('[data-toggle="tooltip"]').tooltip()
        })
    },

    mounted () {

    }

}

</script>

<template>
 	<div class="nb-margin-bottom nb-margin-top">
        <label-title icon="fa-dollar" title="Recebimentos"></label-title><br>
        <div class="row summary-border">
            <div class="col-md-4 col-4">
                <div class="summary-statement-container">
                        <small>A Receber</small>
                        <div class="summary-number">
                            <small>R$</small>
                            {{ receber | format }}
                        </div>
                </div>
            </div>
            <div class="col-md-4 col-4">
                <div class="summary-statement-container">
                        <small>recebido</small>
                        <div class="summary-number">
                            <small>R$</small>
                            {{ recebido | format }}
                        </div>
                </div>
            </div>
            <div class="col-md-4 col-4">
                <div class="summary-statement-container">
                        <small>Vencido</small>
                        <div class="summary-number">
                            <small>R$</small>
                            {{ vencido | format }}
                        </div>
                </div>
            </div>
        </div>
        <div class="mainbox" v-for="(fin, index) in finList" v-bind:key="index">
            <div v-if="fin.baixado=='S'" class="mark-green"></div>
            <div v-if="fin.aberto=='S'" class="mark-gray"></div>
            <div class="box">
                <div class="row">
                    <div class="col-md-1 col-2">
                        <label class="lbl-list">Parcela</label>
                        <span class="data-list">{{ fin.parcela }}</span>
                    </div>
                    <div class="col-md-2 col-2">
                        <label class="lbl-list">Vencimento</label>
                        <span class="data-list">{{ data(fin.dtv) }}</span>
                    </div>
                    <div class="col-md-2 col-2">
                        <label class="lbl-list">Valor</label>
                        <span class="data-list">{{ fin.vlr | format }}</span>
                    </div>
                    <div class="col-md-2 col-2">
                        <label class="lbl-list">Recebido em</label>
                        <span class="data-list">{{ data(fin.dtb) }}</span>
                    </div>
                    <div class="col-md-2 col-2">
                        <label class="lbl-list">Valor Recebido</label>
                        <span class="data-list">{{ fin.vpago | format }}</span>
                    </div>
                    <div class="col-md-2 col-2">
                        <!-- <v-button title="Editar" icon="fa-pencil" @click="handleEdit(fin.codfin)"></v-button> -->
                        <v-button v-if="fin.aberto=='S' || fin.emite_boleto=='S'" title="Emitir Boleto" icon="fa-barcode" @click="handleEmiteBoleto(fin.codfin)"></v-button>
                        <v-button v-if="fin.aberto=='S'" title="Baixar como recebido" icon="fa-check" @click="handleBaixar(fin.codfin)"></v-button>
                    </div>
                </div>
            </div>
        </div>

    </div>


</template>

<style>

.summary-border {
    /* border: dotted 1px #C9D3DD; */
    padding: 20px;
}

.summary-statement-container {
    margin-top: -23px;
    width: 180px;
    float: left;
}

.summary-statement-container small {
    color: #7A7A7F;
    font-size: 13px;
    float: right;
    position: relative;
    top: -6px;
}

.summary-number {
    color: #656565;
    font-size: 24px;
    float: left;
    font-weight: 600;
    width: 180px;
    text-align: right;
    /* font-family: "proxima-nova-condensed" !important; */
}

.summary-number small {
    font-size: 18px;
    color: #656565;
    top: 0;
    left: 3px;
    position: relative;
    float: none;
    /* font-family: "proxima-nova-condensed" !important; */
}

</style>


// WEBPACK FOOTER //
// src/forms/pedido-titulos.vue